module.exports = __webpack_public_path__ + "img/35.4a9d8077.jpg";